export const NET_POSITIONS = "NET_POSITIONS";
export const NET_POSITIONS_ERROR = "NET_POSITIONS_ERROR";
export const NET_POSITIONS_HIDE_ERROR = "NET_POSITIONS_HIDE_ERROR";
export const NET_POSITIONS_START_LOADER = "NET_POSITIONS_START_LOADER";
export const NET_POSITIONS_STOP_LOADER = "NET_POSITIONS_STOP_LOADER";
